import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { BackArrowIcon } from "../../assets/icons/icons";
import Skeleton from "react-loading-skeleton";
import { DisplayAvatar } from "../common/DisplayAvatar";
import { useNavigate } from "react-router-dom";

const { BackButton } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const GroupAndUserDisplayCard = ({ loadingData = false, details = {}, forGroup = true, uuid, isMobileView }) => {
  const navigate = useNavigate();
  const userData = useUnoSelector((state) => state.user);
 
  return (
    <div className="dashboardTeamInfo">

      {(!loadingData && uuid != userData.user.group.uuid) && <BackButton Icon={<BackArrowIcon />} onBackClick={() => navigate(-1)} />}

      {!loadingData ? (
        <DisplayAvatar forGroup={forGroup} url={details?.avatar} name={details?.username} />
      ) : (
        <Skeleton width={isMobileView ? "2.5rem" : "3rem"} height={isMobileView ? "2.5rem" : "3rem"} circle />
      )}

      <div className="userInfo">
        <div className="nameDes">
          <h6>{!loadingData ? details?.username : <Skeleton width={isMobileView ? "5rem" : "15rem"} />}</h6>
          {!loadingData && forGroup && <span className="des">Group</span>}
        </div>
        <div className="mailId">{!loadingData ? details?.identifier : <Skeleton width={isMobileView ? "10rem" : "25rem"} />}</div>
      </div>
    </div>
  );
};

export default GroupAndUserDisplayCard;